<template>
  <div class="est-room__chat">
    <div ref="list" id="chatMessages" class="est-room__chat-list" aria-live="polite">
      <p v-if="!messages || !messages.length" class="est-room__empty">{{ $t('OnlineMeetingComponent.ChatEmpty') }}</p>

      <div v-for="(m, index) in messages" :key="index" class="est-room__msg" :class="messageClass(m)">
        <span v-if="m.fromSystem == true" class="est-room__msg-system">{{ formatSystemMessage($t(m.message)) }}</span>
        <template v-else>
          <div class="est-room__msg-bubble">{{ m.message }}</div>
          <div class="est-room__msg-meta">{{ m.senderName }} · {{ fromNow(m.created) }}</div>
        </template>
      </div>
    </div>

    <!-- Gönder tuşu panelin dolu aksiyonudur (telefonda Enter gönder tuşu değildir);
         dosya ekleme ataç ikonudur. -->
    <form class="est-room__composer" @submit.prevent="sendMessageToParent">
      <label class="est-room__composer-attach" for="meetingFileInput" :title="$t('UploadFile')">
        <font-awesome-icon icon="fa-solid fa-paperclip" />
        <span class="sr-only">{{ $t('UploadFile') }}</span>
        <input id="meetingFileInput"
               ref="fileInput"
               type="file"
               name="file"
               class="sr-only"
               @change="onFileChanged">
      </label>
      <input v-model="message"
             type="text"
             class="est-room__composer-input"
             :placeholder="$t('OnlineMeetingComponent.TypeMessage')"
             :aria-label="$t('Message')"
             autocomplete="off"
             enterkeyhint="send">
      <button type="submit"
              class="est-room__composer-send"
              :disabled="!canSend"
              :aria-label="$t('Send')"
              :title="$t('Send')">
        <font-awesome-icon icon="fa-solid fa-paper-plane" />
      </button>
    </form>

    <!-- ⚠ Sözleşme: `helpers/dataRefresher.sendSuccessfulFileSignal` yükleme
         bittiğinde bu elemanı `click` ile tetikler; hub'a "SendFile" buradan gider. -->
    <div id="successfulFileSignal" hidden @click="sendSuccessfulFileSignal()"></div>
  </div>
</template>

<script>
  import { fileUploadConfirmation } from '../../../helpers/swalConfirmations'

  export default {
    name: 'MeetingChatComponent',
    props: {
      messages: {
        type: Array,
        default: () => []
      },
      isHost: Boolean,
      hostName: String,
      guestName: String,
      meetingId: String
    },
    data() {
      return {
        message: ""
      };
    },
    computed: {
      username: function () {
        return (this.isHost == true ? this.hostName : this.guestName);
      },
      canSend() {
        return this.message.trim().length > 0;
      }
    },
    methods: {
      isOwn(message) {
        return this.isHost ? message.fromHost == true : message.fromHost == false;
      },
      messageClass(message) {
        if (message.fromSystem == true) return 'is-system';
        return this.isOwn(message) ? 'is-own' : 'is-other';
      },
      formatSystemMessage(msg) {
        return msg.replace("Guest", this.guestName).replace("Host", this.hostName);
      },
      // Göreli zaman arayüz dilinde: moment tüm yerelleri paketle taşır, global
      // yerel ayarı yoktur.
      fromNow(value) {
        return this.$moment(value).locale(this.$i18n.locale).fromNow();
      },
      sendMessageToParent() {
        if (!this.canSend) return;

        this.$store.state.Meeting.meethub.invoke("SendTextMessage", { message: this.message.trim(), senderName: this.username });
        this.message = "";
      },
      scrollToBottom() {
        const list = this.$refs.list;
        if (list) list.scrollTop = list.scrollHeight;
      },
      onFileChanged(event) {
        fileUploadConfirmation(event, this.meetingId, this.isHost, this.username);
      },
      sendSuccessfulFileSignal() {
        this.$store.state.Meeting.meethub.invoke("SendFile");
      }
    },
    watch: {
      // Yeni mesaj listenin sonuna eklenir; kaydırma da oraya iner. Eski hâl bunu
      // üst bileşenden `getElementById` + setTimeout ile yapıyordu.
      'messages.length'() {
        this.$nextTick(() => this.scrollToBottom());
      }
    },
    mounted() {
      this.scrollToBottom();
    }
  }
</script>
